import { FC, ReactNode } from 'react';
import { alpha, Box, lighten, useTheme } from '@mui/material';

interface LayoutProps {
  children?: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ children }: LayoutProps) => {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          height: '100vh',
          minWidth: 0, // Don't ever let this item overflow the parent's bounds.
          flex: 1,
          '.MuiPageTitle-wrapper': {
            background: theme.palette.mode === 'dark' ? theme.colors.alpha.trueWhite[5] : theme.colors.alpha.white[50],
            marginBottom: `${theme.spacing(2)}`,
            boxShadow:
              theme.palette.mode === 'dark'
                ? '0 1px 0 ' +
                  alpha(lighten(theme.colors.primary.main, 0.7), 0.15) +
                  ', 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)'
                : '0px 2px 4px -3px ' +
                  alpha(theme.colors.alpha.black[100], 0.1) +
                  ', 0px 5px 12px -4px ' +
                  alpha(theme.colors.alpha.black[100], 0.05),
          },
        }}
      >
        <Box
          sx={{
            zIndex: 5,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            maxHeight: '100vh',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  );
};
